module.exports = __webpack_public_path__ + "static/media/sydney.8417a8eb.svg";